import { PropsWithChildren, ReactNode } from 'react';
import style from './field-wrapper.module.css';
import { Label } from '../../../label';
import { Text } from '../../../typography';
import { FieldError } from 'react-hook-form';
import { HelpButton } from '../../../help-button';
import { cn } from '../../../../utils';
import React from 'react';

export type FieldWrapperProps = PropsWithChildren<{
  id?: string;
  label?: string;
  helpText?: string;
  required?: boolean;
  requiredText?: string | ReactNode;
  error?: FieldError;
  className?: string;
}>;

export function FieldWrapper({
  id,
  label,
  helpText,
  children,
  required,
  requiredText,
  className,
  ...props
}: FieldWrapperProps) {
  return (
    <div className={cn(className, style['field-wrapper'])}>
      <div className={style['label']}>
        {!!label && (
          <Label htmlFor={id} {...props} data-label={label}>
            {label}
            {required && <Required text={requiredText} />}
          </Label>
        )}
        {!!helpText && <HelpButton children={helpText} />}
      </div>
      <div
        className={cn(props.error?.message ? 'error' : undefined, style.field)}
      >
        {React.Children.map(children, (child) =>
          props.error
            ? React.cloneElement(child as React.ReactElement, {
                error: props.error,
              })
            : (child as React.ReactElement),
        )}
      </div>
      {props.error?.message && (
        <Text color="danger" variant="body-small">
          {props.error.message}
        </Text>
      )}
    </div>
  );
}

function Required({ text }: { text: string | ReactNode }) {
  return <span className={style.required}>{text}</span>;
}
